import script from "./CompareCharts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareCharts.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__